import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { stringify } from 'qs'

import styles from './social.scss'

class TwitterButton extends PureComponent {

	render() {
		const twitterObject = this.props.dataObject
		let twitterQuery = {}
		if (twitterObject.message_full) {
			twitterQuery = {
				text: twitterObject.message_full,
			}
		} else {
			twitterQuery = {
				...twitterObject,
			}
		}
		const twitterUrl = 'https://twitter.com/intent/tweet?'+stringify(twitterQuery)
		const twitterHandler = () => {
			this.props.onSelect()
			window.open(twitterUrl, 'tweet', 'height=300,width=550,resizable=1')
		}

		return <a className={styles.icon} onClick={twitterHandler}>
			<svg className={styles.svg} height="50" width="50" viewBox="-5 -5 50 50"><g className={styles.g} fill="#6A686A"><path d="M20-2.913C32.632-2.913 42.912 7.365 42.912 20c0 12.632-10.28 22.91-22.912 22.91S-2.913 32.632-2.913 20C-2.913 7.365 7.37-2.913 20-2.913M20-5C6.19-5-5 6.19-5 20c0 13.807 11.19 25 25 25 13.805 0 25-11.193 25-25C45 6.192 33.805-5 20-5"/><path d="M35.637 19.162c-1.1.19-2.695-.006-3.542-.358 1.757-.144 2.948-.943 3.405-2.027-.632.388-2.6.817-3.685.412-.056-.255-.114-.497-.173-.717-.824-3.044-3.66-5.495-6.628-5.2.24-.098.485-.188.73-.27.324-.114 2.243-.428 1.94-1.105-.256-.596-2.6.45-3.04.588.58-.22 1.546-.594 1.65-1.266-.896.123-1.77.544-2.447 1.156.245-.26.43-.58.47-.928-2.38 1.524-3.77 4.592-4.89 7.57-.886-.857-1.67-1.53-2.37-1.906-1.97-1.058-4.326-2.163-8.026-3.538-.11 1.226.607 2.858 2.676 3.938-.445-.058-1.267.074-1.923.232.27 1.406 1.137 2.563 3.5 3.122-1.075.07-1.638.317-2.142.85.494.976 1.694 2.122 3.852 1.886-2.4 1.037-.98 2.957.975 2.67-3.33 3.445-8.583 3.194-11.6.31 7.875 10.75 24.988 6.357 27.54-3.992 1.914.01 3.038-.67 3.735-1.418"/></g></svg>
			{ this.props.shouldShowName && <span className={styles.name}>Twitter</span> }
		</a>

	}

}

TwitterButton.defaultProps = {
	customClass: 'normal',
	onSelect: () => {},
	shouldShowName: true,
}

TwitterButton.propTypes = {
	dataObject: PropTypes.object,
	onSelect: PropTypes.func,
	shouldShowName: PropTypes.bool,
}

export default TwitterButton
